import { BiLineWidth, kBiVizStyleOptionNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biPatchedOption, biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kWidths: BiLineWidth[] = [1, 2, 3];

/** Line width, smoothing and points, for lines and areas. */
export const LineOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const line = biPatchedOption(style, 'line', {});
  const set = (patch: Partial<typeof line>) =>
    onChange(
      biWithStyleOption(style, 'line', biPatchedOption(style, 'line', patch)),
    );
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.line}
      onReset={
        style?.line
          ? () => onChange(biWithStyleOption(style, 'line', undefined))
          : null
      }
    >
      <StyleRow label="线宽">
        {kWidths.map(width => (
          <BiChip
            key={width}
            label={['细', '标准', '粗'][width - 1]}
            selected={line.width === width}
            onPress={() => set({ width })}
          />
        ))}
      </StyleRow>
      <StyleRow label="线型">
        <BiChip
          label="折线"
          selected={!line.smooth}
          onPress={() => set({ smooth: false })}
        />
        <BiChip
          label="平滑"
          selected={line.smooth}
          onPress={() => set({ smooth: true })}
        />
      </StyleRow>
      <StyleRow label="数据点">
        <BiChip
          label="显示"
          selected={line.showPoints}
          onPress={() => set({ showPoints: true })}
        />
        <BiChip
          label="隐藏"
          selected={!line.showPoints}
          onPress={() => set({ showPoints: false })}
        />
      </StyleRow>
    </StyleGroup>
  );
});
